export default "__VITE_ASSET__BJUIpDk1__"